import NavEditor from './NavEditor'

class Bridge {

	constructor(bridgeE) {
		const data = (bridgeE => {
			try {
				return JSON.parse(bridgeE.value)
			} catch (e) {
				return {
					items: [],
				}
			}
		})(bridgeE)

		this.bridgeE = bridgeE
		bridgeE.setAttribute('type', 'hidden')

		this.container = this.createContainer()
		this.app = new Vue({
			data() {
				return { data }
			},
			el: this.container,
			components: {
				NavEditor,
			},
			template: `<NavEditor v-model="data"></NavEditor>`,
			watch: {
				data: {
					deep: true,
					handler() {
						bridgeE.value = JSON.stringify(this.data)
					}
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
